import React, { useCallback } from 'react';
import { TranslationKeys } from '../../../../translations';
import { useBreadcrumb } from '../../../../components/Breadcrumbs';
import { useConnectionInspectorQuery } from '../../../../hooks/api/admin';
import type { CardState } from './types';

export const useConnectionInspectorPage = () => {
  useBreadcrumb(TranslationKeys.menu_adminPanel_connectionInspector);

  const [inputValue, setInputValue] = React.useState('');
  const [submittedId, setSubmittedId] = React.useState('');

  const { data, isFetching, isFetched } = useConnectionInspectorQuery({
    variables: { connectionId: submittedId },
    options: { enabled: !!submittedId },
  });

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  }, []);

  const handleSearch = useCallback(() => {
    setSubmittedId(inputValue.trim());
  }, [inputValue]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') handleSearch();
    },
    [handleSearch],
  );

  const connectionState: CardState = isFetching
    ? 'loading'
    : !submittedId
    ? 'idle'
    : isFetched && !data
    ? 'not-found'
    : data
    ? 'found'
    : 'idle';

  const dependentState: CardState = connectionState === 'not-found' ? 'idle' : connectionState;

  return {
    inputValue,
    data,
    isFetching,
    connectionState,
    dependentState,
    handleInputChange,
    handleSearch,
    handleKeyDown,
  };
};
